import { useEffect } from "react";
import { TopBar } from "./kit";
import LogStepEyebrow from "./LogStepEyebrow";
import LogMatchScorecardStep from "./LogMatchScorecardStep";
import { useChromelessOverride } from "../context/ChromelessOverrideContext";
import { useRetireTextSize } from "../context/RetireTextSizeContext";
// Issue #758, following #757 review round 2's own shape (LogGroundFlow.jsx)
// exactly: this step's own navy TopBar, reusing the SAME three shared
// controls (NotificationsBell/AccessibilityMenu/AccountMenu) rather than
// forking them, and the same chromeless/text-size-retirement wiring for
// exactly the duration this component is mounted.
import { AccessibilityMenu } from "./AccessibilityMenu";
import { AccountMenu } from "./AccountMenu";
import { NotificationsBell } from "./NotificationsBell";

/**
 * The step's own page surface (mirrors `LogGroundFlow.jsx`). Mounted only
 * while `PerformanceTracking.jsx`'s own scorecard-step gate is true — see
 * that file's `showLogScorecardStep`.
 *
 * `mode`: "create" (a fresh match, arrived from step 1 — carries the step
 * counter), "edit" (opened from the match list — no step counter, no
 * ground step; DirectionA2.dc.html's own "editing-a-match" commentary
 * state) or "finish" (#1150: a planned match whose day has passed, opened by
 * Add how it went — headed "How did it go?", no step counter either).
 */
export default function LogScorecardFlow(props) {
  const { mode } = props;
  const { setActive: setChromeless } = useChromelessOverride();
  const { setRetired: setTextSizeRetired } = useRetireTextSize();
  useEffect(() => {
    setChromeless(true);
    setTextSizeRetired(true);
    return () => {
      setChromeless(false);
      setTextSizeRetired(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    // Round-5 token-check, same reasoning as `LogGroundFlow.jsx`'s own root
    // — an explicit `color` so nothing under this mount inherits the app
    // shell's off-palette default.
    <div data-testid="log-scorecard-flow" style={{ color: "var(--nw-ink)" }}>
      <TopBar
        variant="navy"
        // PR #887 review, B4 — `topbar-logo` + the home link; player-only
        // screen, home is always `/dashboard`.
        homeHref="/dashboard"
        homeLabel="CricketCompass — go to your dashboard"
        // DirectionA2.dc.html:49 draws "Step 2 of 3" on the fresh-log path
        // only; the editing commentary state (:187-190) draws no step
        // counter at all.
        endControls={
          <>
            <NotificationsBell compact />
            <AccessibilityMenu hideTextSize />
            {/* #780 (D140) — the drawn empty account circle; see AccountMenu.jsx's own docstring on the `empty` prop. */}
            <AccountMenu empty />
          </>
        }
        data-testid="log-step-2-topbar"
      />
      {mode !== "edit" && mode !== "finish" && <LogStepEyebrow step={2} total={3} />}
      <LogMatchScorecardStep {...props} />
    </div>
  );
}
